import React from 'react';
import StatusDropdownCell from './StatusDropdownCell';
import TeamMembersCell from './TeamMembersCell';
import EditableTextInput from './EditableTextInput';
import { PRIORITY_COLORS } from '../constants';

export default function TaskCellContent({ task, col, updateTask, statusOptions, taskStatusConfig, handleAddStatusOption, currentUser, handleOpenEditStatusModal, members, getBrazilDate }) {
  const val = task[col.id];
  switch (col.type) {
    case 'text':
      return <EditableTextInput type="text" className="bg-transparent w-full text-center outline-none focus:bg-slate-800 rounded py-0.5 px-1 text-slate-300" value={typeof val === 'string' ? val : ''} onCommit={(nextValue) => updateTask(task.id, col.id, nextValue)} placeholder="-" />;
    case 'status':
      return <StatusDropdownCell value={typeof val === 'string' ? val : 'VAZIO'} options={statusOptions} onChange={(newVal) => updateTask(task.id, col.id, newVal)} onAddOption={handleAddStatusOption} currentUser={currentUser} onEditStatus={handleOpenEditStatusModal} />;
    case 'priority':
      return <StatusDropdownCell value={typeof val === 'string' ? val : 'VAZIO'} options={PRIORITY_COLORS} onChange={(newVal) => updateTask(task.id, col.id, newVal)} />;
    case 'people':
      return <TeamMembersCell taskMembers={Array.isArray(val) ? val : []} allMembers={members} onChange={(newTeam) => updateTask(task.id, col.id, newTeam)} />;
    case 'date':
      return <input type="date" style={{ colorScheme: 'dark' }} className="bg-transparent w-full text-center outline-none focus:bg-slate-800 rounded py-0.5 text-slate-300 cursor-pointer" value={typeof val === 'string' ? val : ''} onChange={(e) => updateTask(task.id, col.id, e.target.value)} />;
    case 'numbers':
      return <EditableTextInput type="number" className="bg-transparent w-full text-center outline-none focus:bg-slate-800 rounded py-0.5 text-blue-400 font-mono" value={typeof val === 'number' || typeof val === 'string' ? val : ''} onCommit={(nextValue) => updateTask(task.id, col.id, nextValue)} placeholder="0" />;
    case 'readonly': {
      const formattedDate = val ? val.split('-').reverse().join('-') : '-';
      return <span className="text-slate-400 text-sm font-mono">{formattedDate}</span>;
    }
    case 'prazo': {
      const config = taskStatusConfig?.[task.status];
      const slaDays = config?.slaDays ?? 0;
      const controlaPrazo = config?.controlaPrazo ?? false;
      const statusEntry = task.dataStatus;

      if (!controlaPrazo || !statusEntry) {
        return <span className="text-slate-500">—</span>;
      }

      if (task.status === 'FINALIZADO') {
        const dataFinalizacao = task.dataFinalizacao;
        if (!dataFinalizacao) {
          return <span className="text-slate-500">-</span>;
        }
        const [sy, sm, sd] = statusEntry.split('-').map(Number);
        const [fy, fm, fd] = dataFinalizacao.split('-').map(Number);
        const end = new Date(fy, fm - 1, fd);
        const expectedEnd = new Date(sy, sm - 1, sd + slaDays);
        const finalizadoNoPrazo = end <= expectedEnd;
        return (
          <span className={`text-xs font-semibold px-2 py-1 rounded ${finalizadoNoPrazo ? 'bg-blue-500/20 text-blue-400' : 'bg-orange-500/20 text-orange-400'}`}>
            {finalizadoNoPrazo ? 'Finalizado no Prazo' : 'Finalizado fora do Prazo'}
          </span>
        );
      }

      const today = getBrazilDate();
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      const [ty, tm, td] = todayStr.split('-').map(Number);
      const [se, sm2, sd2] = statusEntry.split('-').map(Number);
      const dataHoje = new Date(ty, tm - 1, td);
      const dataEntrada = new Date(se, sm2 - 1, sd2);
      const daysInStatus = Math.floor((dataHoje - dataEntrada) / 86400000);
      const isDentro = daysInStatus <= slaDays;

      const remaining = slaDays - daysInStatus;
      let label = isDentro ? 'DENTRO' : 'FORA';
      if (remaining === 0) label = 'HOJE';

      return (
        <span className={`text-xs font-semibold px-2 py-1 rounded ${isDentro ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
          {label}
        </span>
      );
    }
    default:
      return <span className="text-slate-500">-</span>;
  }
}
